import { makeStyles } from '@material-ui/core';
import React from 'react';
import {
  Datagrid,
  List,
  Responsive,
  SimpleList,
  TopToolbar,
  CheckboxGroupInput,
  SelectField,
  TextInput
} from 'react-admin';
import omit from 'lodash/omit';

import { ReportIcon } from '../../core/themes/icons/ReportIcon';
import Empty from '../../core/components/list/Empty';
import ListTitleBar from '../../core/components/ListTitleBar';
import LinkField from '../../core/components/LinkField';
import Filter from '../../core/components/list/StyledFilter';
import { reportTypes } from './ReportLookups';

const useStyles = makeStyles({
  dataGridHead: {
    '& tr': {
      '& th:last-child': {
        width: '114px'
      }
    }
  },
  root: {
    marginRight: 'auto'
  },
  labelCheckbox: {
    display: 'none'
  },
  checkbox: {
    height: 'auto'
  },
  checkboxGroup: {
    marginBottom: '0',
    '& .MuiFormGroup-row': {
      marginLeft: '6px',
      '& .MuiCheckbox-root': {
        height: '24px'
      },
      '& .MuiFormControlLabel-label': {
        fontSize: '14px',
        color: '#212121',
        fontWeight: 'normal'
      }
    }
  }
});

const Actions = ({
  displayedFilters,
  filters,
  filterValues,
  resource,
  showFilter
}) => {
  const classes = useStyles();
  return (
    <TopToolbar classes={{ root: classes.root }}>
      {filters &&
        React.cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: 'button'
        })}
    </TopToolbar>
  );
};

const Filters = props => {
  const classes = useStyles();
  return (
    <Filter variant="standard" {...props}>
      <CheckboxGroupInput
        alwaysOn
        source="type"
        classes={{
          label: classes.labelCheckbox
        }}
        className={classes.checkboxGroup}
        options={{
          classes: {
            root: classes.checkbox
          }
        }}
        choices={reportTypes.map(reportType => ({
          name: `${reportType.name} Report`,
          id: reportType.id
        }))}
      />
      <TextInput
        label="Search by Name"
        source="name"
        allowEmpty
        alwaysOn
        options={{ autoComplete: 'off' }}
      />
    </Filter>
  );
};

const ReportsTitle = () => {
  return <ListTitleBar type="Administrative Reports" icon={<ReportIcon />} />;
};

const ReportList = props => {
  const {
    hasCreatePermission,
    hasEditPermission,
    hasDeletePermission,
    hasReadPermission,
    ...rest
  } = props;
  const classes = useStyles();

  return (
    <List
      {...omit(rest, ['userProfile'])}
      title={<ReportsTitle />}
      sort={{ field: 'id', order: 'ASC' }}
      exporter={false}
      pagination={null}
      actions={<Actions />}
      filters={<Filters />}
      empty={<Empty />}
      syncWithLocation
      bulkActionButtons={false}
      filterDefaultValues={{
        type: reportTypes.map(reportType => reportType.id)
      }}
    >
      <Responsive
        small={
          <SimpleList
            primaryText={record => record.reportTypeName}
            secondaryText={record => record.type}
            tertiaryText={record => record.id}
          />
        }
        medium={
          <Datagrid
            classes={{
              thead: classes.dataGridHead
            }}
          >
            <LinkField label="Report Name" source="name" sortable={false} />
            <SelectField
              label="Report Type"
              source="type"
              choices={reportTypes}
              sortable={false}
            />
          </Datagrid>
        }
      />
    </List>
  );
};

export default ReportList;
